import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TarotReading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmartText","SmartTitle"] */ "/vercel/path0/src/components/ui/SmartFont.tsx");
